import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PLATFORM_LABELS } from "@/lib/helpers";

export default function Analytics() {
  const [summary, setSummary] = useState(null);
  useEffect(() => { api.get("/dashboard/summary").then(r => setSummary(r.data)); }, []);
  if (!summary) return <div className="font-mono-data text-sm text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-6 min-w-0" data-testid="analytics-page">
      <div>
        <div className="eyebrow mb-1">Analytics</div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tighter text-navy">Catalog analytics</h1>
        <p className="text-muted-foreground mt-2 text-sm">Understand what's driving your catalog quality across marketplaces.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div className="kpi-card"><div className="kpi-label">Total products</div><div className="kpi-value">{summary.total_products}</div></div>
        <div className="kpi-card"><div className="kpi-label">Avg health</div><div className="kpi-value">{summary.avg_health}</div></div>
        <div className="kpi-card"><div className="kpi-label">Live listings</div><div className="kpi-value text-brand-green">{Object.values(summary.platform_live).reduce((a,b)=>a+b,0)}</div></div>
        <div className="kpi-card"><div className="kpi-label">Missing listings</div><div className="kpi-value text-orange">{Object.values(summary.platform_missing).reduce((a,b)=>a+b,0)}</div></div>
      </div>

      <div className="card-base p-6">
        <div className="section-title mb-4">Live vs Missing by Platform</div>
        <div className="space-y-3">
          {Object.entries(summary.platform_live).map(([p, live]) => {
            const missing = summary.platform_missing[p] || 0;
            const total = live + missing || 1;
            const livePct = (live / total) * 100;
            return (
              <div key={p} className="min-w-0">
                <div className="flex items-center justify-between text-sm mb-1.5 gap-2">
                  <span className="font-medium text-navy">{PLATFORM_LABELS[p]}</span>
                  <span className="font-mono-data text-xs text-muted-foreground shrink-0">{live} live · {missing} missing</span>
                </div>
                <div className="h-2.5 bg-secondary rounded-full overflow-hidden flex relative">
                  {live > 0 && <div className="bg-brand-green" style={{width:`${livePct}%`}}/>}
                  {missing > 0 && <div style={{width:`${100-livePct}%`, background:"hsl(var(--ecom-orange))"}}/>}
                  {live === 0 && missing === 0 && <div className="w-full bg-muted-foreground/10"/>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
